import { render } from "./SortableTable.vue?vue&type=template&id=9552ca96&scoped=true&ts=true"
import script from "./SortableTable.vue?vue&type=script&lang=ts"
export * from "./SortableTable.vue?vue&type=script&lang=ts"

import "./SortableTable.vue?vue&type=style&index=0&id=9552ca96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9552ca96"]])

export default __exports__